/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Build_Deliverable_LabelInputs */

const en_how_we_work_build_deliverable_label = /** @type {(inputs: How_We_Work_Build_Deliverable_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you can review`)
};

const lv_how_we_work_build_deliverable_label = /** @type {(inputs: How_We_Work_Build_Deliverable_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ko varat pārskatīt`)
};

/**
* | output |
* | --- |
* | "What you can review" |
*
* @param {How_We_Work_Build_Deliverable_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_build_deliverable_label = /** @type {((inputs?: How_We_Work_Build_Deliverable_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Build_Deliverable_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_build_deliverable_label(inputs)
	return en_how_we_work_build_deliverable_label(inputs)
});